require("./dist/css/xeditable.css");
module.exports = require("./dist/js/xeditable.js");


//////////////////
// WEBPACK FOOTER
// angular-xeditable (bower component)
// module id = 1411
// module chunks = 0